// Copyright (c) Move Closer 2022.

import { Component, Mixins } from 'vue-property-decorator'
import { Authentication, AuthServiceType } from '@movecloser/front-core'

import { IProfileService, ProfileServiceType } from '../../../profile/contracts'
import { ISubscriptionsMixin, UserModel } from '../contracts'
import { Inject, logger } from '../../../../support'

import { AuthMixin } from './authMixin'

@Component<SubscriptionsMixin>({
  created (): void {
    this.getUserSubscriptions()
  }
})
export class SubscriptionsMixin extends Mixins(AuthMixin) implements ISubscriptionsMixin {
  @Inject(AuthServiceType)
  protected readonly authService!: Authentication<UserModel>

  @Inject(ProfileServiceType)
  protected readonly profileService!: IProfileService

  public userSubscriptions: Record<string, boolean> | null = null

  public async getUserSubscriptions (): Promise<void> {
    if (!this.isLoggedInUser) {
      return
    }

    this.$emit('isLoading', true)
    const token = String(this.authService.token)

    try {
      const response = await this.profileService.getUserSubscriptions(token)
      this.userSubscriptions = response.agreements
    } catch (e) {
      logger(e, 'warn')
    } finally {
      this.$emit('isLoading', false)
    }
  }

  public isSubscribed (subscription: string): boolean {
    if (!this.userSubscriptions) {
      return false
    }

    return Boolean(this.userSubscriptions[subscription])
  }
}
